







































import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  name: 'CertificationPopup'
})
export default class CertificationPopup extends Vue {
  // 是否显示弹窗
  @Prop({
    type: Boolean,
    default: false
  })
  isPopup!: boolean
  // 当前语言
  @Prop({
    type: String,
    default: 'ug'
  })
  language!: string
  // 标题
  @Prop({
    type: String,
    default: '真人认证'
  })
  title!: string

  // 文案
  @Prop({
    type: String,
    default: '为了打款精准无误，需要进行真人认证确保提现是账号本人操作'
  })
  content!: string

  // 左按钮
  @Prop({
    type: String,
    default: '暂时不用'
  })
  lfbtn!: string

  // 右按钮
  @Prop({
    type: String,
    default: '真人认证'
  })
  lrbtn!: string

  // 真人认证
  handleCertification() {
    this.$emit('handleCertification')
  }

  //   暂时不用
  handleWithout() {
    this.$emit('handleWithout')
  }
}
